import { callApi } from '@local_modules/generic/fetch.js'

export async function loadCurrenciesRates () {
  const url = '/currencies/rates'
  const loadedData = await callApi(url)
  // console.log('loadCurrenciesRates loadedData', loadedData)
  return loadedData
}
